// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main Suggestions Box */
.suggestions-box {
    background-color: #f1f8ff;
    padding: 15px;
    border-radius: 5px;
    border: 1px solid #91caff;
  }
  
  /* Suggestions List */
  .suggestions-list {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  
  /* Individual Suggestion Item */
  .suggestion-item {
    padding: 8px 0;
    border-bottom: 1px solid #e1e4e8;
  }
  
  .suggestion-item:last-child {
    border-bottom: none;
  }
  `, "",{"version":3,"sources":["webpack://./src/styles/SuggestionsWidget.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;IACI,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA,qBAAqB;EACrB;IACE,gBAAgB;IAChB,UAAU;IACV,SAAS;EACX;;EAEA,+BAA+B;EAC/B;IACE,cAAc;IACd,gCAAgC;EAClC;;EAEA;IACE,mBAAmB;EACrB","sourcesContent":["/* Main Suggestions Box */\n.suggestions-box {\n    background-color: #f1f8ff;\n    padding: 15px;\n    border-radius: 5px;\n    border: 1px solid #91caff;\n  }\n  \n  /* Suggestions List */\n  .suggestions-list {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n  }\n  \n  /* Individual Suggestion Item */\n  .suggestion-item {\n    padding: 8px 0;\n    border-bottom: 1px solid #e1e4e8;\n  }\n  \n  .suggestion-item:last-child {\n    border-bottom: none;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
